import * as OrderCommentsActions from "./orderComments.actions";
import * as _ from "lodash";

export interface State {
  generalComments: any;
  priorityScreenUsername: any;
}

const initialState: State = {
  generalComments: null,
  priorityScreenUsername: null,
};

export function orderCommentsReducer(
  state = initialState,
  action: OrderCommentsActions.OrderCommentsActions
) {
  switch (action.type) {
    case OrderCommentsActions.SET_ORDER_COMMENTS:
      return {
        ...state,
        generalComments: action.payload,
      };
    case OrderCommentsActions.SET_ORDER_PRIORITY_SCREEN_USERNAME:
      return {
        ...state,
        priorityScreenUsername: action.payload,
      };

    default:
      return state;
  }
}
